<template>
  <div class="game__status-bar__match">
    <div class="game__status-bar__match__live-count">
      <div class="game__status-bar__match__live-count__status">{{$t(`cardGame.status.${selectGame.status}`)}}</div>
      <div class="game__status-bar__match__live-count__count">{{gameStat.LiveCount}}</div>
    </div>
    <div class="game__status-bar__match__result">
      <div class="game__status-bar__match__result__score">
        <img :src="getUrlShield(selectGame.teamLocal.shield)" alt="" v-if="selectGame.teamLocal.shield != ''">
        {{gameStat.Score}}
        <img :src="getUrlShield(selectGame.teamVisitor.shield)" alt="" v-if="selectGame.teamVisitor.shield != ''">  
      </div>
      <div class="game__status-bar__match__result__time">{{getEmunStatus()}} {{getTime()}}</div>
    </div>
  </div>
</template>


<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      gameStat: state => state.InfoModule.gameStat,
      selectGame: state => state.InfoModule.selectGame,
    })
  },
  methods: {
    getUrlShield(shield) {
      return `${process.env.VUE_APP_CDN_URL_SHIELDS}${shield}`
    },
    getEmunStatus() {
      const status = {
        pending: "P",
        beforematch: this.$t("game.BM"),
        firsthalf: "",
        halftime: "ET",
        secondhalf: "",
        extratime: "",
        penalties: "PE",
        finished: "F"
      }
      return status[this.gameStat.Status]
    },
    getTime() {
      if (this.gameStat.Status == 'firsthalf') {
        return this.gameStat.Time > 45 ? `45' +${this.gameStat.Time - 45}'` : `${this.gameStat.Time}'`
      } else if (this.gameStat.Status == 'secondhalf') {
        return this.gameStat.Time > 90 ? `90' +${this.gameStat.Time - 90}'` : `${this.gameStat.Time}'`
      } else if (this.gameStat.Status == 'extratime') {
        return this.gameStat.Time > 120 ? `120' +${this.gameStat.Time - 120}'` : `${this.gameStat.Time}'`
      }
      return this.gameStat.Time
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.game__status-bar__match {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;

  @media (min-width: $break-sm) {
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
  }

  .game__status-bar__match__live-count {
    background: $lightblue;
    border: 3px solid $lightblue;
    border-radius: $redondeadobig;
    font-weight: 900;
    display: flex;
    align-items: center;
    justify-content: space-between;
    overflow: hidden;
    margin-bottom: $margin-milli;

    @media (min-width: $break-sm) {
      margin-bottom: 0;
      margin-right: $margin-base;
    }

    &__status {
      background: $white;
      color: $lightblue;
      padding: $margin-milli / 2 $margin-milli;
    }

    &__count {
      color: $white;
      padding: $margin-milli / 2 $margin-milli;
      text-align: center;
      flex-grow: 1;
    }
  }

  .game__status-bar__match__result {
    border-radius: $redondeadobig;
    border: 3px solid $white;
    overflow: hidden;
    font-weight: 700;
    text-align: center;
    min-width: 96px;

    &__time {
      background: $deepblue;
      color: $white;
      padding: $margin-milli / 2 $margin-milli;
      min-height: $margin-kilo;
    }

    &__score {
      background: $white;
      color: $deepblue;
      padding: $margin-milli / 2 $margin-milli;
      min-height: $margin-kilo;
      display: flex;
      justify-content: center;
      align-items: center;
      letter-spacing: 2px;

      img {
        width: 24px;
        margin: 0 $margin-milli;
      }
    }
  }
}
</style>